import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import Slider from 'react-slick'

export default function ServiceContent({
  cssModifier,
  bodyCopyHtml,
  bulletPointsHtml,
  headingText,
  primaryImage,
  secondaryImage,
  tertiaryImage,
  quarternaryImage,
}) {
  const slickSlidersettings = {
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    fade: true,
    infinite: true,
    lazyLoad: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <StyledComponent className={`quote-block ${cssModifier ? `quote-block--${cssModifier}` : ''}`}>
      <Fade>
        <hr />
        <div className="wrapper">
          <div className="col col--1">
            {headingText && <h3 className="heading">{headingText}</h3>}
            {bodyCopyHtml && <div className="body-copy" dangerouslySetInnerHTML={{__html: bodyCopyHtml}} />}
            {bulletPointsHtml && <div className="bullet-points" dangerouslySetInnerHTML={{__html: bulletPointsHtml}} />}
          </div>
          <div className="col col--2">
            <div className="photos">
              <Slider {...slickSlidersettings}>
                {primaryImage.url && (
                  <picture>
                    <source media="(min-width: 850px)" srcSet={primaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 750px)" srcSet={primaryImage.thumbnails.large.url} />
                    <source media="(min-width: 500px)" srcSet={primaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 0px)" srcSet={primaryImage.thumbnails.small.url} />
                    <img
                      src={primaryImage.url}
                      alt={primaryImage.alt}
                      width={primaryImage.dimensions?.width}
                      height={primaryImage.dimensions?.height}
                    />
                  </picture>
                )}
                {secondaryImage.url && (
                  <picture>
                    <source media="(min-width: 850px)" srcSet={secondaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 750px)" srcSet={secondaryImage.thumbnails.large.url} />
                    <source media="(min-width: 500px)" srcSet={secondaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 0px)" srcSet={secondaryImage.thumbnails.small.url} />
                    <img
                      src={secondaryImage.url}
                      alt={secondaryImage.alt}
                      width={secondaryImage.dimensions?.width}
                      height={secondaryImage.dimensions?.height}
                    />
                  </picture>
                )}
                {tertiaryImage.url && (
                  <picture>
                    <source media="(min-width: 850px)" srcSet={tertiaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 750px)" srcSet={tertiaryImage.thumbnails.large.url} />
                    <source media="(min-width: 500px)" srcSet={tertiaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 0px)" srcSet={tertiaryImage.thumbnails.small.url} />
                    <img
                      src={tertiaryImage.url}
                      alt={tertiaryImage.alt}
                      width={tertiaryImage.dimensions?.width}
                      height={tertiaryImage.dimensions?.height}
                    />
                  </picture>
                )}
                {quarternaryImage.url && (
                  <picture>
                    <source media="(min-width: 850px)" srcSet={quarternaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 750px)" srcSet={quarternaryImage.thumbnails.large.url} />
                    <source media="(min-width: 500px)" srcSet={quarternaryImage.thumbnails.medium.url} />
                    <source media="(min-width: 0px)" srcSet={quarternaryImage.thumbnails.small.url} />
                    <img
                      src={quarternaryImage.url}
                      alt={quarternaryImage.alt}
                      width={quarternaryImage.dimensions?.width}
                      height={quarternaryImage.dimensions?.height}
                    />
                  </picture>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </Fade>
    </StyledComponent>
  )
}

const StyledComponent = styled.div`
  margin: 6rem 0;

  .wrapper {
    margin-top: 6rem;
    display: flex;
    flex-direction: column;

    @media (min-width: 850px) {
      flex-direction: row-reverse;
      gap: 2rem;
    }
  }

  .col {
    &--1 {
      margin-bottom: 2rem;
      @media (min-width: 850px) {
        margin-bottom: 0;
        width: 60%;
      }
    }
    &--2 {
      @media (min-width: 850px) {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 40%;
      }
    }
  }

  .heading {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 1.2;
    margin: 0 0 2rem 0;
    padding: 0 0 0 0;
    text-transform: uppercase;

    @media (min-width: 375px) {
      font-size: 2.3rem;
    }
  }

  .body-copy {
    margin: 0;
  }

  img {
    aspect-ratio: 7.5 / 5;
    object-fit: cover;
    object-position: center;
  }

  .bullet-points {
    width: 100%;
    margin: 2rem 0 0 0;

    ul {
      display: grid;
      gap: 0px;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      margin: 0;
      padding: 0 0 0 2rem;

      li {
        width: 100%;
      }
    }
  }

  // .photos {
  //   .slick-arrow {
  //     display: none !important;
  //   }
  // }
`
